import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import _ from 'lodash';

import ProductCardSmall from 'common/components/_partials/product/cardSmall/mobilonline';

import { fetchProducts } from 'common/actions/PageActions';
import { Container, Row, Column } from 'common/components/styleguide/grid';
import { getPageDataSelector } from 'common/selectors/page';
import { capfl } from 'common/utils/index';

import SS from 'common/pages/_style/index';

class FooterList extends PureComponent {
  componentDidMount() {
    const {
      fetchFavouriteProductsData,
      fetchLatestProductsData,
      fetchNewestProductsData
    } = this.props;
    fetchFavouriteProductsData();
    fetchLatestProductsData();
    fetchNewestProductsData();
  }
  render() {
    const { t, productsFavourite, productsLatest, productsNewest } = this.props;
    return (
      <SS.SectionFooterProducts>
        <Container>
          <Row>
            <Column size={{ xs: 12, sm: 4 }}>
              <SS.SectionTitle>
                {capfl(t('special offer'))}
              </SS.SectionTitle>
              <SS.SectionContent>
                {_.map(productsFavourite, (item, i) => {
                  return (
                    <Column
                      size={{ xs: 12 }}
                      key={'footer-products-list-favourite-item-' + i}
                    >
                      <ProductCardSmall data={item} />
                    </Column>
                  );
                })}
              </SS.SectionContent>
            </Column>
            <Column size={{ xs: 12, sm: 4 }}>
              <SS.SectionTitle>{capfl(t('recommended'))}</SS.SectionTitle>
              <SS.SectionContent>
                {_.map(productsLatest, (item, i) => {
                  return (
                    <Column
                      size={{ xs: 12 }}
                      key={'footer-products-list-latest-item-' + i}
                    >
                      <ProductCardSmall data={item} />
                    </Column>
                  );
                })}
              </SS.SectionContent>
            </Column>
            <Column size={{ xs: 12, sm: 4 }}>
              <SS.SectionTitle>{capfl(t('new'))}</SS.SectionTitle>
              <SS.SectionContent>
                {_.map(productsNewest, (item, i) => {
                  return (
                    <Column
                      size={{ xs: 12 }}
                      key={'footer-products-list-newest-item-' + i}
                    >
                      <ProductCardSmall data={item} />
                    </Column>
                  );
                })}
              </SS.SectionContent>
            </Column>
          </Row>
        </Container>
      </SS.SectionFooterProducts>
    );
  }
}

const makeMapStateToProps = () => {
  const getPageData = getPageDataSelector();
  const mapStateToProps = (state, props) => {
    return {
      productsFavourite: _.get(
        getPageData(state, props),
        'productsFavourite',
        []
      ),
      productsLatest: _.get(getPageData(state, props), 'productsLatest', []),
      productsNewest: _.get(getPageData(state, props), 'productsNewest', [])
    };
  };
  return mapStateToProps;
};

const mapDispatchToProps = dispatch => {
  return {
    fetchFavouriteProductsData: () => {
      dispatch(
        fetchProducts(3, 'productsFavourite', {
          favourite: 1,
          orderBy: 'priority-desc'
        })
      );
    },
    fetchLatestProductsData: () => {
      dispatch(fetchProducts(3, 'productsLatest', { orderBy: 'time-desc' }));
    },
    fetchNewestProductsData: () => {
      dispatch(
        fetchProducts(3, 'productsNewest', { new: 1, orderBy: 'priority-desc' })
      );
    }
  };
};

const FooterListConnected = connect(
  makeMapStateToProps,
  mapDispatchToProps
)(FooterList);

export default withTranslation()(FooterListConnected);
